import "core-js/stable/index.js";
import "regenerator-runtime/runtime.js";
import React, {Component} from "react";
import {createComponent} from "@lit/react";
import UI_MODES from "@digintent/pn-highlight-lib/components/sidebar/ui_modes";
import {Sidebar as SidebarWC} from "@digintent/pn-highlight-lib/components/sidebar/Sidebar";
import "@digintent/pn-highlight-lib/assets/css-variables.css";

const PNSidebar = createComponent({
	tagName:      "pn-sidebar",
	elementClass: SidebarWC,
	react:        React
});

class Sidebar extends Component {
	render() {
		return <PNSidebar
			mode={UI_MODES.SIDEBAR}
			{...this.props}
		/>;
	}
}

export default Sidebar;
